"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-24 bg-foreground/10 animate-pulse" />
        <div className="h-5 w-32 bg-foreground/10 animate-pulse" />
        <div className="h-5 w-20 bg-foreground/10 animate-pulse" />
        <div className="h-5 w-28 bg-foreground/10 animate-pulse" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-[0.9375rem] font-default text-foreground/60 hover:text-foreground transition-colors duration-200 border-b border-transparent hover:border-foreground/30 pb-0.5">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const programmes = [{
  label: "Systemické konstelace",
  href: "/ServicesPage",
  link: {
    to: "/SystematicConstellationsPage"
  }
}, {
  label: "SCIO feedback",
  href: "/ServicesPage"
}, {
  label: "Bachovy esence",
  href: "/ServicesPage"
}, {
  label: "Odpínání",
  href: "/ServicesPage"
}, {
  label: "Kurzy",
  href: "/ServicesPage"
}];
const connect = [{
  label: "Instagram",
  href: "https://www.instagram.com/epiona.life/",
  newTab: true,
  link: {
    href: "https://www.instagram.com/epiona.life/",
    newTab: true
  }
}, {
  label: "Facebook",
  href: "https://www.facebook.com/soulheal",
  newTab: true,
  link: {
    href: "https://www.facebook.com/profile.php?id=61569008331773",
    newTab: true
  }
}];
const legal = [{
  label: "Ochrana soukromí",
  href: "/OchranaSOUKROMÍ"
}, {
  label: "Obchodní podmínky",
  href: "/TermsAndConditions2",
  link: {
    href: "https://epiona.cz/wp-admin/post.php?post=622&action=wvc-editor",
    newTab: true
  }
}, {
  label: "Etický kodex",
  href: "/EtickýKodex"
}];
export default function Footer() {
  return <section data-section-id="10681" id="zápatí" className="bg-background text-foreground py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-4 md:grid-cols-12 gap-4 md:gap-6">
          <div className="col-span-4 md:col-span-4 md:pr-8">
            <Link to="/" aria-label="EPIONA — Domů" className="inline-block">
              <WvcLogo className="h-7 w-auto" style={{
              filter: "none"
            }} />
            </Link>
            <p className="mt-8 text-lg md:text-xl font-default text-foreground/60 leading-[1.5] tracking-[-0.005em] max-w-sm">
              Prostor pro vaši duši, psychickou rovnováhu a cestu k vnitřnímu uzdravení.
            </p>
          </div>
          
          <div className="col-span-2 md:col-span-2 md:col-start-10 mt-8 md:mt-0">
            <h4 className="text-sm font-default font-semibold uppercase tracking-[0.04em] text-foreground mb-4">
              Kontakt
            </h4>
            <div className="h-px w-8 bg-foreground/20 mb-6" />
            <ul className="flex flex-col gap-3">
              {connect.map((item, i) => <li data-index={i} key={item.label}>
                  <Link className="text-[0.9375rem] font-default text-foreground/60 hover:text-foreground transition-colors duration-200 border-b border-transparent hover:border-foreground/30 pb-0.5 underline cursor-pointer" {...item.link}><Link to={item.href} newTab={item.newTab}>
                    {item.label}
                  </Link></Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="mt-16 md:mt-20 bg-foreground/20" />

        <div className="grid grid-cols-4 md:grid-cols-12 gap-4 md:gap-6 mt-8">
          <div className="col-span-4 md:col-span-6">
            <p className="font-mono text-[0.8125rem] tracking-[0.01em] text-foreground/50">
              {"© EPIONA 2024  ·  Česká republika"}
            </p>
          </div>
          <div className="col-span-4 md:col-span-6 md:text-right">
            <div className="flex flex-col md:items-end gap-4 font-mono text-[0.8125rem] tracking-[0.01em]">
              <ul className="flex flex-wrap gap-x-4 md:justify-end">
                {legal.map((item, i) => <li data-index={i} key={item.label} className="flex items-center gap-4">
                    <Link className="text-foreground/50 hover:text-foreground transition-colors duration-200 underline cursor-pointer underline cursor-pointer" {...item.link}><Link to={item.href}>
                      {item.label}
                    </Link></Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}